module.exports = __webpack_public_path__ + "img/u1.4b349bbd.jpg";